import React from 'react';
import TimelineCard from './TimelineCard';

const TimelineSection = ({ timelineData }) => {
    if (!timelineData || !timelineData.companies) {
        return <div>Loading timeline data...</div>;
    }

    return (
        <div className="row g-4">
            {timelineData.companies.map((company) => (
                <TimelineCard key={company.id} company={company} />
            ))}
        </div>
    );
};

export default TimelineSection;